import { render, staticRenderFns } from "./FormBuilder.vue?vue&type=template&id=1bf98e14&scoped=true&"
import script from "./FormBuilder.vue?vue&type=script&lang=js&"
export * from "./FormBuilder.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilder.vue?vue&type=style&index=0&id=1bf98e14&lang=scss&scoped=true&"
import style1 from "./FormBuilder.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf98e14",
  null
  
)

export default component.exports